import type * as Graphql from "@hireroo/graphql/client/urql";

import { state } from "./State";

export const setCompany = (company: Graphql.GetCompanyForGeneralSettingsCompanyFragment): void => {
  state.company = company;
};
